import i18n from '@/language/i18n';

export default class ErrorC {

    constructor(error, fieldId = undefined, formFields = undefined, fieldName = undefined) {
        this.message = error.message;
        this.fieldName = fieldName ?? i18n.t('Common.general');
        this.fieldRef = fieldId;
        this.isFocusable = formFields?.[fieldId]?.isFocusable ?? false;
    }
}
